<template>
  <div v-if="userGroups !== null">
    <!-- 検索 -->
    <SearchInput
      v-model="search"
      class="ml-3 mr-5"
    />

    <v-layout v-if="is_admin">
      <!-- toggle of edit mode -->
      <CheckBoxInput
        v-model="createEditMode"
        class="ml-4"
        :label="$t('CreateEditMode')"
        switch-mode
      />
      <v-spacer />
      <!-- button for creating a new group-->
      <v-btn
        v-if="createEditMode"
        variant="flat"
        class="ma-3 text-secondary"
        @click="openCreateDialog()"
      >
        <v-icon
          class="mr-1"
          color="secondary"
          icon="mdi-plus"
        />
        {{ $t('UserGroup.AddTop') }}
      </v-btn>
    </v-layout>

    <!-- group checkboxes -->
    <v-treeview
      v-model:selected="selectedMultiple"
      class="pb-3"
      open-all
      density="compact"
      expand-icon="mdi-chevron-right"
      collapse-icon="mdi-chevron-down"

      :search="search"
      :items="userGroups"
      item-title="user_group_name"
      item-children="children"

      item-value="id"
      select-strategy="classic"
      selected-color="secondary"
      :selectable="!createEditMode"
    >
      <template #title="{ item, isOpen }">
        <!-- title -->
        <span class="text-body-1">
          {{ item.user_group_name }}
        </span>
        <!-- the number of children -->
        <span
          v-if="item.children && item.children.length > 0 && !isOpen"
          class="text-grey text-caption"
        >
          ({{ item.children.length }})
        </span>
      </template>

      <!-- create/edit mode -->
      <template
        v-if="createEditMode && is_admin"
        #append="data"
      >
        <v-btn
          size="small"
          variant="flat"
          icon="mdi-plus"
          density="comfortable"
          @click="openCreateDialog(data.item)"
        >
          <v-icon
            size="small"
            color="secondary"
            icon="mdi-plus"
          />
        </v-btn>
        <v-btn
          size="small"
          variant="flat"
          icon="mdi-pencil"
          density="comfortable"
          @click="openEditDialog(data.item)"
        >
          <v-icon
            size="small"
            color="secondary"
            icon="mdi-pencil"
          />
        </v-btn>
        <v-btn
          size="small"
          variant="flat"
          icon="mdi-delete"
          density="comfortable"
          @click="openDeleteDialog('user-groups/' + data.item.id + '/')"
        >
          <v-icon
            size="small"
            color="secondary"
            icon="mdi-delete"
          />
        </v-btn>
      </template>
    </v-treeview>

    <CreateEditUserGroupDialog
      v-if="is_admin"
      :key="createEditKey"
      v-model="createEditDialog"
      :current-data="editCurrentData"
      :create-from-parent="createFromParent"
      @reload="get()"
    />

    <!-- 削除ダイアログ -->
    <DeleteDialog
      v-if="is_admin"
      v-model="deleteDialog"
      :api-address="deleteApiAddress"
      @reload="get()"
    >
      {{ $t('UserGroup.DeleteInfo') }}
    </DeleteDialog>
  </div>
  <div
    v-else
    class="pa-3"
  >
    ...
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import CheckBoxInput from '@/components/parts/inputs/CheckBoxInput'
  import CreateEditUserGroupDialog from '@/components/dialogs/CreateEditUserGroupDialog'
  import DeleteDialog from '@/components/dialogs/DeleteDialog'
  import _ from 'lodash'
  import SearchInput from '@/components/parts/inputs/SearchInput'

  export default {
    components: {
      SearchInput,
      DeleteDialog,
      CreateEditUserGroupDialog,
      CheckBoxInput
    },
    emits: ['selected-data'],
    data: () => ({
      userGroups: null,
      createEditMode: false,
      createEditDialog: false,
      editCurrentData: null,
      createFromParent: null,
      selectedMultiple: null,
      selectedSingle: null,
      createEditKey: 0,
      deleteDialog: false,
      deleteApiAddress: null,
      search: null
    }),
    computed: {
      ...mapGetters(['ui', 'login']),
      is_admin () {
        return Boolean(this.login.profile.is_admin)
      }
    },
    watch: {
      selectedMultiple () {
        if (this.selectedMultiple[0]) {
          this.selectedSingle = null
        }
        this.$emit('selected-data', this.selectedMultiple)
      },
      selectedSingle () {
        if (this.selectedSingle[0]) {
          this.selectedMultiple = null
        }
        this.$emit('selected-data', this.selectedSingle)
      }
    },
    created () {
      this.get()
    },
    methods: {
      dataReset () {
        this.editCurrentData = null
        this.createFromParent = null
      },
      selectReset () {
        this.selectedMultiple = []
        this.selectedSingle = null
      },
      get () {
        this.$http.get('user-groups-tree/', { params: { limit: 1000 } }).then(
          (res) => {
            this.userGroups = this.toTreeViewItems(res.data.results)
            this.createEditKey++
          })
      },
      openCreateDialog (currentData) {
        this.dataReset()
        if (currentData) {
          setTimeout(() => {
            this.createFromParent = currentData.id
          })
        }
        this.createEditDialog = true
      },
      openEditDialog (currentData) {
        this.dataReset()
        this.editCurrentData = _.cloneDeep(currentData)
        this.createEditDialog = true
      },
      openDeleteDialog (apiAddress) {
        this.deleteApiAddress = apiAddress
        this.deleteDialog = true
      },
      /**
       * Convert data into the format of tree view
       * @param {array} items list of items to be shown in tree view
       */
      toTreeViewItems (items) {
        const res = []
        items.forEach((item) => {
          // clear empty children
          if (!item.children) res.push(item)
          else if (item.children.length) {
            // recursively check empty children
            const obj = { ...item }
            obj.children = this.toTreeViewItems(item.children)
            res.push(obj)
          } else {
            const obj = { ...item }
            delete obj.children
            res.push(obj)
          }
        })

        return res
      }
    }
  }
</script>
